window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {

  document.addEventListener('change', function(e) {
    if (!e.target || e.target.id !== 'set-id-completion-selection') return;
    location.href = '/portfolio/set_completion?set_id=' + e.target.value + '&type=' + getUrlVars()['type'];
  });

  bindPopover();

  window.addEventListener("popstate", function(e) {
    var url = document.location.toString();
    if (url.match('#')) {
      var toggleEl = document.getElementById('toggle-' + url.split('#')[1]);
      if (toggleEl) toggleEl.click();
    }
  });
});

var hideColumnSortSpinner = function(column) {
  document.querySelectorAll('.tablesorter .ajax-indicator').forEach(function(el) { el.style.display = 'none'; });
  document.querySelectorAll('th .sort-icon').forEach(function(el) { el.style.display = ''; });
};
window.hideColumnSortSpinner = hideColumnSortSpinner;

function getUrlVars() {
  var vars = [], hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}
